// Reveal each .koi-sold-overlay (and .koi-sold-letters, the ghosted sold
// letters) only after its companion image has loaded, so the marks appear in
// the same frame the photo paints (no fade, no flash-of-overlay over a
// still-blank image box). Pairs with the
// visibility:hidden -> visibility:visible CSS gate inside
// snippets/koi-sold-overlay.liquid.

(() => {
  const GATED = '[data-koi-sold-overlay], [data-koi-sold-letters]';

  const reveal = (overlay) => {
    overlay.dataset.koiSoldReady = '';
  };

  const wireOne = (overlay) => {
    if (overlay.dataset.koiSoldReady !== undefined) return;
    const wrapper = overlay.parentElement;
    if (!wrapper) return reveal(overlay);
    // :scope > img picks the wrapper's own img child, never an <img> inside
    // the overlay's SVG. Falls through to immediate reveal for video / 3D
    // media, where there's no <img> to wait on.
    const img = wrapper.querySelector(':scope > img');
    if (!img) return reveal(overlay);
    if (img.complete && img.naturalWidth > 0) return reveal(overlay);
    img.addEventListener('load', () => reveal(overlay), { once: true });
    img.addEventListener('error', () => reveal(overlay), { once: true });
  };

  const init = (root = document) => {
    root.querySelectorAll(GATED).forEach(wireOne);
  };

  // Catch AJAX-injected cards: facets.js (collection filters), quick-add,
  // cart-drawer recommendations, infinite scroll. One observer at body
  // scope is cheap and means new surfaces don't have to know about us.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(GATED)) wireOne(node);
        node.querySelectorAll?.(GATED).forEach(wireOne);
      });
    }
  });

  const start = () => {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.koiSoldOverlay = { refresh: init };
})();
